/**
 * 工具函数统一导出文件
 */

// 屏幕分辨率检测工具
export * from './screen-detector';

// 请求工具
export * from './request';

// 无限加载工具
export * from './infinite-scroll';

// SEO工具
export * from './seo';

/**
 * 全局工具注册
 */
import { destroyScreenDetector, initScreenDetector } from './screen-detector';

// 全局工具对象
const globalUtils = {
  // 屏幕检测相关
  screen: {
    initDetector: initScreenDetector,
    destroyDetector: destroyScreenDetector,
  },
};

// 为Vue应用提供安装方法
export const installUtils = {
  install(app: any) {
    // 挂载到Vue实例
    app.config.globalProperties.$utils = globalUtils;
    
    // 挂载到window对象（可选）
    if (typeof window !== 'undefined') {
      (window as any).$utils = globalUtils;
    }
  },
};

// 类型声明
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $utils: typeof globalUtils;
  }
}